// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Jasper from '../../../Texas/data/counties/Jasper.geo.json'
import Newton from '../../../Texas/data/counties/Newton.geo.json'
import Liberty from '../../../Texas/data/counties/Liberty.geo.json'
import Hardin from '../../../Texas/data/counties/Hardin.geo.json'
import Orange from '../../../Texas/data/counties/Orange.geo.json'
import Jefferson from '../../../Texas/data/counties/Jefferson.geo.json'
import Chambers from '../../../Texas/data/counties/Chambers.geo.json'
import Galveston from '../../../Texas/data/counties/Galveston.geo.json'
import Brazoria from '../../../Texas/data/counties/Brazoria.geo.json'

const counties = {
  Jasper,
  Newton,
  Liberty,
  Hardin,
  Orange,
  Jefferson,
  Chambers,
  Galveston,
  Brazoria
}

export default counties
